import { useParams } from "react-router-dom";

import { useGetSessionByKey } from "@/features/session/api/get-session-by-key";
import { cn } from "@/lib/utils";

type CallTitleProps = {
  className?: string;
};

export function CallTitle({ className }: CallTitleProps) {
  const { key } = useParams();

  const { data: session, isSuccess: isSessionSuccess } = useGetSessionByKey(
    key ?? "",
  );

  if (!isSessionSuccess) {
    return null;
  }

  return (
    <div className={cn("text-md text-foreground", className)}>
      {session.name}
    </div>
  );
}
